// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3LQ1h","title":"Images90_title__3H71h","images":"Images90_images__2psPN"};